{
  "Accessibility Menu": "Hozzáférhetőségi menü",
  "Reset settings": "Beállítások visszaállítása",
  "Close": "Bezárás",
  "Content Adjustments": "Tartalom beállításai",
  "Adjust Font Size": "Betűméret beállítása",
  "Highlight Title": "Cím kiemelése",
  "Highlight Links": "Linkek kiemelése",
  "Readable Font": "Olvasható betűtípus",
  "Color Adjustments": "Színbeállítások",
  "Dark Contrast": "Sötét kontraszt",
  "Light Contrast": "Világos kontraszt",
  "High Contrast": "Magas kontraszt",
  "High Saturation": "Magas telítettség",
  "Low Saturation": "Alacsony telítettség",
  "Monochrome": "Monokróm",
  "Contrast": "Kontraszt",
  "Invert Colors": "Színek invertálása",
  "Tools": "Eszközök",
  "Reading Guide": "Olvasási útmutató",
  "Stop Animations": "Animációk leállítása",
  "Big Cursor": "Nagy kurzor",
  "Increase Font Size": "Betűméret növelése",
  "Decrease Font Size": "Betűméret csökkentése",
  "Letter Spacing": "Betűtávolság",
  "Line Height": "Sor magasság",
  "Font Weight": "Betűtípus vastagsága",
  "Dyslexia Font": "Dyslexia betűtípus",
  "Language": "Nyelv",
  "Open Accessibility Menu": "Hozzáférhetőségi menü megnyitása",
  "Widget Settings": "Widget beállításai",
  "Widget Position": "Widget pozíciója",
  "Top Left": "Felül balra",
  "Top Center": "Felül középen",
  "Top Right": "Felül jobbra",
  "Center Left": "Középen balra",
  "Center Right": "Középen jobbra",
  "Bottom Left": "Alul balra",
  "Bottom Center": "Alul középen",
  "Bottom Right": "Alul jobbra",
  "Screen Reader": "Képernyőolvasó",
  "Voice Navigation": "Hangnavigáció",
  "Custom Color": "Egyéni szín",
  "Change the site's colors": "Módosítsa az oldal színeit",
  "Backgrounds": "Háttérképek",
  "Headings": "Címek",
  "Contents": "Tartalmak",
  "Reset colors": "Színek visszaállítása",
  "Image Desaturation": "Kép színtelenítése",
  "Search languages": "Nyelvek keresése",
  "No languages found": "Nem találhatók nyelvek",
  "Accessibility Profiles": "Akadálymentesítési profilok",
  "Motor Impaired": "Mozgáskorlátozott",
  "Big cursor, voice navigation, and no animations.": "Nagy kurzor, hangnavigáció és nincs animáció.",
  "Blind": "Vak",
  "Screen reader helpers with higher contrast.": "Képernyőolvasó segédletek erősebb kontraszttal.",
  "Color Blind": "Színtévesztés",
  "High contrast palette with desaturated media.": "Nagy kontrasztú paletta csökkentett telítettségű médiával.",
  "Dyslexia": "Diszlexia",
  "Friendly font, extra spacing, stronger weight.": "Olvasható betűtípus, nagyobb térköz és erősebb vastagság.",
  "Low vision": "Gyengénlátás",
  "Dark contrast and 130% magnification.": "Sötét kontraszt és 130 %-os nagyítás.",
  "Cognitive & Learning": "Kognitív és tanulási",
  "Highlights key sections and enables voice help.": "Kiemeli a fontos részeket és engedélyezi a hangos segítséget.",
  "Seizure & Epileptic": "Rohamok és epilepszia",
  "Stops animations and desaturates imagery.": "Leállítja az animációkat és csökkenti a képek telítettségét.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Olvasási útmutató, kiemelt hivatkozások és nyugodtabb paletta.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
